__turbopack_context__.v({
  "className": "lato_4fb8ebb8-module__Dk7kOq__className",
  "variable": "lato_4fb8ebb8-module__Dk7kOq__variable",
});
